import React from 'react';
import WorkforceUnlockShiftsSvg from './assets/UnlockShiftsClock.svg';
import { ImageProps } from './interface';

export function WorkforceUnlockShiftsImage(props: ImageProps) {
  return <WorkforceUnlockShiftsSvg {...props} />;
}
